import React, { useContext, useState } from "react";
import { Button, Space } from "antd";
import CustomTable from "../../components/CustomTable";
import useApi from "../../hooks/useApi";
import { AppStateContext } from "../../context/AppContext";
import { listBanner, deleteBanner } from "../../constants/API/API";
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import AddBanner from "./AddBanner";
import ViewBanner from "./ViewBanner";
import UpdateBanner from "./UpdateBanner";
import useFilter from "../../hooks/useFilter";
import DeleteRecord from "../../components/DeleteRecord";

const BannerIndex = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Banner Management");

  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(new Date().getTime());
  const [data, setData] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState();
  const [filters, setFilters] = useFilter({
    sortField: "createdOn",
    sort: "desc",
    name: "",
  });

  const handleViewClick = (record) => {
    setViewModal(true);
    setSelectedBanner(record);
  };

  const handleEditClick = (record) => {
    setEditModal(true);
    setSelectedBanner(record);
  };

  useApi({
    callback: listBanner,
    payload: { ...filters },
    dependencies: [refresh, filters],
    shouldCallApi: true,
    onSuccess: (data) => {
      setData(data?.list || []);
      setTotalDocs(data?.totalDocs || 0);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const columns = [
    {
      title: "Branch Name",
      dataIndex: "branchId",
      key: "branchId",
      render: (branch) => branch?.name || "-"
    },
    {
      title: "Banner Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Banner Link",
      dataIndex: "link",
      key: "link",
      render: (text) =>
        text ? (
          <a
            href={text}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#1677ff" }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (text ? new Date(text).toLocaleDateString() : "-"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => handleViewClick(record)}
            icon={<EyeOutlined />}
            title="View"
          />

          <Button
            type="primary"
            onClick={() => handleEditClick(record)}
            icon={<EditOutlined />}
            title="Edit"
          />

          <DeleteRecord
            _id={record._id}
            callback={() => deleteBanner(record._id, { isDeleted: true })}
            setLoading={setLoading}
            setRefresh={setRefresh}
            trigger={true}
            type="Banner"
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <CustomTable
        data={data}
        addFn={() => setAddModal(true)}
        loading={loading}
        columns={columns}
        totalDocs={totalDocs}
        filters={filters}
        setFilters={setFilters}
        searchField={["title"]}
        searchPlaceholder={"Search by Banner Title"}
        hideAddButton
        fields={{ search: true, range: true }}
        onSearch={(value) => setFilters((prev) => ({ ...prev, search: value }))}
      />

      {addModal && (
        <AddBanner
          visible={addModal}
          setVisible={setAddModal}
          refresh={() => setRefresh((x) => !x)}
        />
      )}
      {editModal && (
        <UpdateBanner
          editVisible={editModal}
          setEditVisible={setEditModal}
          selectedBelt={selectedBanner}
          refresh={() => setRefresh((x) => !x)}
        />
      )}
      {viewModal && (
        <ViewBanner
          viewVisible={viewModal}
          setViewVisible={setViewModal}
          selectedBelt={selectedBanner}
        />
      )}
    </>
  );
};

export default BannerIndex;
